export default __webpack_public_path__ + "63b918cf44d70f48ba855dc751acc78b.svg";